export default () => ({
    homes: [],
    home: {
        title: '',
        image: '',
        description: '',
        permalink: '#',
        sections: [

        ]
    },
    locations: [],
    markerMapping: [],
    selectedMarker: '',

    isMobile: false,

    init() {
        this.fetchServerData();
        this.setIsMobile();
        this.fetchLocationData().then(() => {
            this.loadGoogleMap();
        });
    },

    selectHomeById(id) {
        const homeItem = this.homes.find(home => home.id === id);
        this.home = homeItem;
    },

    async fetchLocationData() {
        try {
            const response = await fetch(`/wp-json/custom/v1/homelocations?${new Date().getTime()}`);
            const data = await response.json();
            this.locations = data.locations;
        } catch (error) {

        }
    },

    loadGoogleMap() {
        const script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAqWWzqtKB-OmqOXg0PEbWUmjCWr3k5VQ8&callback=initMap';
        script.async = true;

        window.initMap = () => {

            const defaultIcon = {
                url: '/wp-content/themes/efhl/assets/images/map-icon.png',
                scaledSize: new google.maps.Size(29, 31), 
            };
            
            const highlightedIcon = {
                url: '/wp-content/themes/efhl/assets/images/map-icon.png', 
                scaledSize: new google.maps.Size(49, 53), 
            };

            const map = new google.maps.Map(document.getElementById('map'), {
                center: { lat: 51.83788239872361, lng: -0.89041276021916714 },
                zoom: 6,
                disableDefaultUI: true,
                styles: [
                    {
                        "elementType": "geometry",
                        "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                        {
                            "color": "#616161"
                        }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [
                        {
                            "color": "#bdbdbd"
                        }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [
                        {
                            "color": "#757575"
                        }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                        {
                            "color": "#ffffff"
                        }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                        {
                            "color": "#757575"
                        }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [
                        {
                            "color": "#dadada"
                        }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                        {
                            "color": "#616161"
                        }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                        ]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                        ]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                        {
                            "color": "#c9c9c9"
                        }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                        ]
                    }
                    ]
            });

            var infowindow = new google.maps.InfoWindow();
                let currentInfowindow = null;

            this.locations.forEach((location, index) => {

                const marker = new google.maps.Marker({
                    position: new google.maps.LatLng(location[1], location[2]), 
                    icon: defaultIcon,
                    map: map,
                    animation: google.maps.Animation.DROP,
                    title: location[0]
                    
                });

                marker.addListener('click', () => {


                    this.selectHomeById(location[3].ID);

                    if (this.isMobile) {

                        if (currentInfowindow) {
                            currentInfowindow.close();
                        }

                        const currentHome = this.home;

                        (function (location, i,currentHome) {
                            return function () {
                                infowindow.setContent('<div class="infowindow" ><a href="'+currentHome.link+'">'+currentHome.image+'<span class="infowindow__content" ><span class="infowindow__name" >'+location[0]+'</span><span class="infowindow__link" ><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-3 w-3 text-gold-900 inline"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"></path></svg>View Home</span></span></a></div>');
                                infowindow.open(map, marker);
                                currentInfowindow = infowindow; 
                            };
                        })(location, index,currentHome)();
                    
                    } else {
                        if (this.selectedMarker) {
                            this.selectedMarker.setIcon(defaultIcon); 
                        }
                
                        
                        marker.setIcon(highlightedIcon); 
                        this.selectedMarker = marker;
                    }
                    
                    
                });
                
                marker.addListener('mouseover', () => {
                    marker.setAnimation(google.maps.Animation.BOUNCE);
                });
                
                marker.addListener('mouseout', () => {
                    marker.setAnimation(null);
                });

                this.markerMapping[location[3].ID] = marker;

            });
        };

        document.head.appendChild(script);
    },
    
    selectHome(homeItem) {
        this.home = homeItem;

        const marker = this.markerMapping[homeItem.id];

        if (marker) {

            const defaultIcon = {
                url: '/wp-content/themes/efhl/assets/images/map-icon.png', 
                scaledSize: new google.maps.Size(29, 31),
            };

            const highlightedIcon = {
                url: '/wp-content/themes/efhl/assets/images/map-icon.png', 
                scaledSize: new google.maps.Size(49, 53),
            };

            marker.setIcon(highlightedIcon);

            if (this.selectedMarker && this.selectedMarker !== marker) {
                this.selectedMarker.setIcon(defaultIcon);
            }

            this.selectedMarker = marker;
        }
    },

    async fetchServerData() {
        try {
            const response = await fetch(`/wp-json/custom/v1/homes?${new Date().getTime()}`);

            const data = await response.json();

            this.homes = data.homes.map((home, index) => ({
                id: home.id,
                title: home.title,
                image:  home.image,
                description: home.description,
                link: home.permalink,
                location: home.location,
                sections: home.sections
            }));

            this.selectHome(this.homes[0]);
        } catch (error) {
            console.error("Error fetching home data:", error);
        }
    },

    setIsMobile() {
        this.isMobile = window.innerWidth <= 1023;
    }
});
